import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Box } from '@material-ui/core';
import theme from '../../theme';

const useStyles = makeStyles(() => ({
    backdrop: {
        zIndex: 999999,
        color: "#fff",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    circularProgress: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        color: theme.colors.DodgerBlue,

    },
}));

export default function PageLoading() {
    const classes = useStyles();

    return (
        <Box className={classes.backdrop}>
            <CircularProgress
                className={classes.circularProgress}
            />
        </Box>
    );
}
